import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export enum AppMode {
  SHIMMERSEA = 'SHIMMERSEA',
  SWAPLINE = 'SWAPLINE',
}

export type AppState = {
  mode: AppMode;
};

const initialState: AppState = {
  mode: AppMode.SHIMMERSEA,
};

export const appModeSlice = createSlice({
  name: 'appMode',
  initialState,
  reducers: {
    setAppMode: (state, action: PayloadAction<AppMode>) => {
      state.mode = action.payload;
    },
  },
});

// Actions
export const { setAppMode } = appModeSlice.actions
export const getAppMode = (state: AppState) => state.mode;
export default appModeSlice.reducer
